import { createElement } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

function removeInitialLoader() {
  const initialLoader = document.getElementById("initial-loader");
  initialLoader?.remove();
}

function showBootError(error: unknown) {
  console.error("[main] App bootstrap failed:", error);
  removeInitialLoader();

  const root = document.getElementById("root");
  if (!root) return;

  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0a0f1a;color:#e2e8f0;font-family:system-ui;padding:24px;text-align:center;">
      <div>
        <p style="margin:0 0 12px 0;font-size:14px;">Appen kunde inte laddas.</p>
        <button id="retry-app-load" style="padding:10px 14px;border-radius:8px;border:1px solid #334155;background:#111827;color:#e2e8f0;cursor:pointer;">Ladda om</button>
      </div>
    </div>
  `;

  document.getElementById("retry-app-load")?.addEventListener("click", () => {
    window.location.reload();
  });
}

async function withTimeout<T>(promise: Promise<T>, timeoutMs = 20000): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const timeoutPromise = new Promise<T>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(`Bootstrap import timeout after ${timeoutMs}ms`));
    }, timeoutMs);
  });

  try {
    return await Promise.race([promise, timeoutPromise]);
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}

async function loadAppModule() {
  try {
    return await withTimeout(import("./App.tsx"));
  } catch (error) {
    if (!import.meta.env.DEV) throw error;
    const bust = Date.now();
    return await withTimeout(import(/* @vite-ignore */ `./App.tsx?t=${bust}`));
  }
}

async function renderApp() {
  try {
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error("Root element saknas");
    }

    const { default: App } = await loadAppModule();
    removeInitialLoader();
    createRoot(rootElement).render(createElement(App));
  } catch (error) {
    showBootError(error);
  }
}

void renderApp();

